import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/dashboards/DashboardByVersion.vue";
/* import Automotive from "../views/dashboards/Automotive.vue";
import SmartHome from "../views/dashboards/SmartHome.vue";
import VRDefault from "../views/dashboards/vr/VRDefault.vue";
import VRInfo from "../views/dashboards/vr/VRInfo.vue";
import CRM from "../views/dashboards/CRM.vue";
import Overview from "../views/pages/profile/Overview.vue";
import Teams from "../views/pages/profile/Teams.vue";
import Projects from "../views/pages/profile/Projects.vue";
import General from "../views/pages/projects/General.vue";
import Timeline from "../views/pages/projects/Timeline.vue";
import NewProject from "../views/pages/projects/NewProject.vue";
import Pricing from "../views/pages/Pricing.vue";
import RTL from "../views/pages/Rtl.vue";
import Charts from "../views/pages/Charts.vue";
import SweetAlerts from "../views/pages/SweetAlerts.vue";
import Notifications from "../views/pages/Notifications.vue";
import Kanban from "../views/applications/Kanban.vue";
import Wizard from "../views/applications/wizard/Wizard.vue";
import DataTables from "../views/applications/DataTables.vue";
import Calendar from "../views/applications/Calendar.vue";
import Analytics from "../views/applications/analytics/Analytics.vue";*/
/* import EcommerceOverview from "../views/ecommerce/overview/Overview.vue"; */
import EditProduct from "../views/products/EditProduct.vue";
/* import ProductPage from "../views/ecommerce/ProductPage.vue"; */
import ProductsList from "../views/products/ProductsList.vue";
import OrderDetails from "../views/orders/details/OrderDetails";
import OrderList from "../views/orders/OrderList";
import CreateOrder from "../views/orders/CreateOrder.vue";
import EditOrder from "../views/orders/EditOrder.vue";
/* import Referral from "../views/ecommerce/Referral";
import Reports from "../views/pages/Users/Reports.vue";
import NewUser from "../views/pages/Users/NewUser.vue";
import Settings from "../views/pages/Account/Settings.vue";
import Billing from "../views/pages/Account/Billing.vue";
import Invoice from "../views/pages/Account/Invoice.vue";
import Security from "../views/pages/Account/Security.vue";
import Widgets from "../views/pages/Widgets.vue";*/
import Basic from "../views/auth/signin/Basic.vue";
/*import Cover from "../views/auth/signin/Cover.vue";
import Illustration from "../views/auth/signin/Illustration.vue";
import ResetBasic from "../views/auth/reset/Basic.vue";
import ResetCover from "../views/auth/reset/Cover.vue";
import ResetIllustration from "../views/auth/reset/Illustration.vue";
import VerificationBasic from "../views/auth/verification/Basic.vue";
import VerificationCover from "../views/auth/verification/Cover.vue";
import VerificationIllustration from "../views/auth/verification/Illustration.vue";
import SignupBasic from "../views/auth/signup/Basic.vue";
import SignupCover from "../views/auth/signup/Cover.vue";
import SignupIllustration from "../views/auth/signup/Illustration.vue"; */
import Error404 from "../views/auth/error/Error404.vue";
import Error403 from "../views/auth/error/Error403.vue";
import Error500 from "../views/auth/error/Error500.vue";
/* import lockBasic from "../views/auth/lock/Basic.vue";
import lockCover from "../views/auth/lock/Cover.vue";
import lockIllustration from "../views/auth/lock/Illustration.vue"; */
//import Almacenes from "../views/stock/Almacen.vue";
//import AlmacenDetalle from "../views/stock/AlmacenDetalle.vue";
//import StockProducto from "../views/stock/StockProductos.vue";
import OrdersbackList from "../views/ordersBack/DevolucionesList.vue";
import OrdersbackDetails from "../views/ordersBack/details/OrderBackDetails.vue";
import PurchasesList from "../views/purchases/PurchaseList.vue";
import PurchaseDetails from "../views/purchases/details/PurchaseDetails.vue";
/* import NewOrder from "../views/ecommerce/Orders/NewOrder";
import NewCompra from "../views/purchases/NewPurchase.vue";
import NewDevolucion from "../views/ordersBack/NewDevolucion.vue"; */
import ShipmentList from "../views/shipments/ShipmentList.vue";
import ShipmentDetails from "../views/shipments/details/ShipmentDetails.vue";

/* import VerProducto from "../views/products/VerProduct.vue"; */
import UserList from "../views/user/UserList.vue"
//import BatchLoadsList from "../views/batchLoads/BatchLoadsList.vue";
import PoDsList from "../views/manifestos/ManifestosList.vue";
import EditPoD from "../views/manifestos/details/EditManifest.vue";
import NewPoD from "../views/manifestos/details/NewManifest.vue";
/* import DashboardAdmin from "../views/administration/dashboard-admin/DashboardAdmin.vue"; */
import DeleteDocumentsList from "../views/administration/Deletes.vue";
import OpenCancelledDocuments from "../views/administration/Cancels.vue";
import PackageList from "../views/administration/packages/PackagesList.vue";
import BrandsList from "../views/administration/clients/ClientList.vue";
import NewEditBrand from "../views/administration/clients/components/NewEditClient.vue";
import OldQueueList from "../views/administration/queues/QueueList.vue";





import LoginPage from "../views/auth/LoginPage.vue"//"../picko/views/auth/signin/LoginPage.vue";










import WarehouseList from "./../picko/views/stock/lists/warehouse/WarehouseList.vue";
import StockProductList from "./../picko/views/stock/lists/products/StockProductList.vue";


import ImportList from "./../picko/views/import/lists/user/ImportList.vue";
import ImportLogList from "./../picko/views/import/logs/user/ImportLogList.vue";


//Customer Service
import CustomerServiceBrandList from "./../picko/views/brand/lists/admin/BrandList.vue";
import CustomerServiceNewBrand from "./../picko/views/brand/forms/brandDetails/BrandDetails.vue";
import CustomerServiceBrandDetails from "./../picko/views/brand/forms/brandDetails/BrandDetails.vue";

import AdminOrderOutboxQueueList from "./../picko/views/integrations/alierSGA/orderOutboxQueue/lists/admin/OrderOutboxQueueList.vue";
import AdminOrderBackOutboxQueueList from "./../picko/views/integrations/alierSGA/orderbackOutboxQueue/lists/admin/OrderBackOutboxQueueList.vue";
import AdminProductOutboxQueueList from "./../picko/views/integrations/alierSGA/productOutboxQueue/lists/admin/ProductOutboxQueueList.vue";
import AdminPurchaseOutboxQueueList from "./../picko/views/integrations/alierSGA/purchaseOutboxQueue/lists/admin/PurchaseOutboxQueueList.vue";



export const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/Dashboard",
  },
  /* {
    path: "/dashboard-admin",
    name: "Dashboard Admin",
    component: DashboardAdmin,
  }, */
  {
    path: "/Dashboard",
    name: "Dashboard",
    component: Dashboard,
  },
  /*{
    path: "/dashboards/automotive",
    name: "Automotive",
    component: Automotive,
  },
  {
    path: "/dashboards/smart-home",
    name: "Smart Home",
    component: SmartHome,
  },
  {
    path: "/dashboards/vr/vr-default",
    name: "VR Default",
    component: VRDefault,
  },
  {
    path: "/dashboards/vr/vr-info",
    name: "VR Info",
    component: VRInfo,
  },
  {
    path: "/dashboards/crm",
    name: "CRM",
    component: CRM,
  },
  {
    path: "/pages/profile/overview",
    name: "Profile Overview",
    component: Overview,
  },
  {
    path: "/pages/profile/teams",
    name: "Teams",
    component: Teams,
  },
  {
    path: "/pages/profile/projects",
    name: "All Projects",
    component: Projects,
  },
  {
    path: "/pages/projects/general",
    name: "General",
    component: General,
  },
  {
    path: "/pages/projects/timeline",
    name: "Timeline",
    component: Timeline,
  },
  {
    path: "/pages/projects/new-project",
    name: "New Project",
    component: NewProject,
  },
  {
    path: "/pages/pricing-page",
    name: "Pricing Page",
    component: Pricing,
  },
  {
    path: "/pages/rtl-page",
    name: "RTL",
    component: RTL,
  },
  {
    path: "/pages/charts",
    name: "Charts",
    component: Charts,
  },
  {
    path: "/pages/widgets",
    name: "Widgets",
    component: Widgets,
  },
  {
    path: "/pages/sweet-alerts",
    name: "Sweet Alerts",
    component: SweetAlerts,
  },
  {
    path: "/pages/notifications",
    name: "Notifications",
    component: Notifications,
  },
  {
    path: "/applications/kanban",
    name: "Kanban",
    component: Kanban,
  },
  {
    path: "/applications/wizard",
    name: "Wizard",
    component: Wizard,
  },
  {
    path: "/applications/data-tables",
    name: "Data Tables",
    component: DataTables,
  },
  {
    path: "/applications/calendar",
    name: "Calendar",
    component: Calendar,
  },
  {
    path: "/applications/analytics",
    name: "Analytics",
    component: Analytics,
  },*/
  /* {
    path: "/ecommerce/overview",
    name: "Overview",
    component: EcommerceOverview,
  }, */
  {
    path: "/MasterData/Products/NewProduct",
    name: "New product",
    component: EditProduct,
  },
  {
    path: "/MasterData/Products/EditProduct/:id",
    name: "Edit product",
    component: EditProduct,
  },
  /* {
    path: "/ecommerce/products/product-page",
    name: "Product Page",
    component: ProductPage,
  }, */
  {
    path: "/MasterData/Products",
    name: "Products list",
    component: ProductsList,
  },
  {
    path: "/Operations/Orders/OrderDetail/:id",
    name: "Order detail",
    component: OrderDetails,
  },
  {
    path: "/Operations/Orders",
    name: "Orders list",
    component: OrderList,
  },
  {
    path: "/Operations/Orders/NewOrder",
    name: "New order",
    component: CreateOrder,
  },
  {
    path: "/Operations/Orders/EditOrder/:id",
    name: "Edit order",
    component: EditOrder,
  },
  /*{
    path: "/ecommerce/referral",
    name: "Referral",
    component: Referral,
  },
  {
    path: "/pages/users/reports",
    name: "Reports",
    component: Reports,
  },
  {
    path: "/pages/users/new-user",
    name: "New User",
    component: NewUser,
  },
  {
    path: "/pages/account/settings",
    name: "Settings",
    component: Settings,
  },
  {
    path: "/pages/account/billing",
    name: "Billing",
    component: Billing,
  },
  {
    path: "/pages/account/invoice",
    name: "Invoice",
    component: Invoice,
  },
  {
    path: "/pages/account/Security",
    name: "Security",
    component: Security,
  },*/
  {
    path: "/authentication/signin/basic",
    name: "Signin Basic",
    component: Basic,
  },
  /*{
    path: "/authentication/signin/cover",
    name: "Signin Cover",
    component: Cover,
  },
  {
    path: "/authentication/signin/illustration",
    name: "Signin Illustration",
    component: Illustration,
  },
  {
    path: "/authentication/reset/basic",
    name: "Reset Basic",
    component: ResetBasic,
  },
  {
    path: "/authentication/reset/cover",
    name: "Reset Cover",
    component: ResetCover,
  },
  {
    path: "/authentication/reset/illustration",
    name: "Reset Illustration",
    component: ResetIllustration,
  },
  {
    path: "/authentication/lock/basic",
    name: "Lock Basic",
    component: lockBasic,
  },
  {
    path: "/authentication/lock/cover",
    name: "Lock Cover",
    component: lockCover,
  },
  {
    path: "/authentication/lock/illustration",
    name: "Lock Illustration",
    component: lockIllustration,
  },
  {
    path: "/authentication/verification/basic",
    name: "Verification Basic",
    component: VerificationBasic,
  },
  {
    path: "/authentication/verification/cover",
    name: "Verification Cover",
    component: VerificationCover,
  },
  {
    path: "/authentication/verification/illustration",
    name: "Verification Illustration",
    component: VerificationIllustration,
  },
  {
    path: "/authentication/signup/basic",
    name: "Signup Basic",
    component: SignupBasic,
  },
  {
    path: "/authentication/signup/cover",
    name: "Signup Cover",
    component: SignupCover,
  },
  {
    path: "/authentication/signup/illustration",
    name: "Signup Illustration",
    component: SignupIllustration,
  },*/
  {
    path: "/authentication/error/error404",
    name: "Error404",
    component: Error404,
  },
  {
    path: "/authentication/error/error403",
    name: "Error403",
    component: Error403,
  },
  {
    path: "/authentication/error/error500",
    name: "Error500",
    component: Error500,
  },
  /* {
    path: "/products/ver-product/:id",
    name: "Ver Artículo",
    component: VerProducto,
  }, */
  /* {
    path: "/stock-almacenes",
    name: "Stock Almacenes",
    component: Almacenes,
  }, */
  


  
  
  /* {
    path: "/stock/almacen-detalle",
    name: "Almacen Detalle",
    component: AlmacenDetalle,
  }, */
  /* {
    path: "/stock-almacen/:id",
    name: "Stock Almacen",
    component: StockProducto,
  },
  {
    path: "/stock-articulos",
    name: "Stock Artículos",
    component: StockProducto,
  }, */
  {
    path: "/Operations/Ordersback",
    name: "Ordersback list",
    component: OrdersbackList,
  },
  {
    path: "/Operations/Ordersback/OrderbackDetail/:id",
    name: "Orderback detail",
    component: OrdersbackDetails,
  },
  {
    path: "/Operations/Purchases",
    name: "Purchases list",
    component: PurchasesList,
  },
  {
    path: "/Operations/Purchases/PurchaseDetail/:id",
    name: "Purchase detail",
    component: PurchaseDetails,
  },
  /*{
    path: "/pedidos/nuevo-pedido",
    name: "Nuevo pedido",
    component: NewOrder,
  },
  {
    path: "/compras/nueva-compra",
    name: "Nueve Compra",
    component: NewCompra,
  },
  {
    path: "/devoluciones/nueva-devolucion",
    name: "Nueva Devolucion",
    component: NewDevolucion,
  },*/
  {
    path: "/Operations/Shipments",
    name: "Shipments list",
    component: ShipmentList,
  },
  {
    path: "/Operations/Shipments/ShipmentDetail/:id",
    name: "Shipment detail",
    component: ShipmentDetails,
  },
  {
    path: "/Operations/PoDs",
    name: "PoDs list",
    component: PoDsList,
  },
  {
    path: "/Operations/PoDs/EditPoD/:id",
    name: "Edit PoD",
    component: EditPoD,
  },
  {
    path: "/Operations/PoDs/NewPoD",
    name: "New PoD",
    component: NewPoD,
  },





  {
    path: "/Management/Users",
    name: "Users list",
    component: UserList,
  },
  {
    path: "/Administration/DeleteDocuments",
    name: "Delete documents",
    component: DeleteDocumentsList,
  },
  {
    path: "/Administration/OpenCancelledDocuments",
    name: "Open cancelled documents",
    component: OpenCancelledDocuments,
  },
  {
    path: "/Administration/Packages",
    name: "Packages list",
    component: PackageList,
  },
  {
    path: "/Administration/Brands",
    name: "Brands list",
    component: BrandsList,
  },
  {
    path: "/Administration/NewBrand",
    name: "New brand",
    component: NewEditBrand,
  },
  {
    path: "/Administration/EditBrand/:id",
    name: "Edit brand",
    component: NewEditBrand,
  },
  {
    path: "/Integrations/OldQueues",
    name: "Old queues list",
    component: OldQueueList,
  },








  {
    path: "/Auth/Login",
    name: "Login page",
    component: LoginPage,
  },







  {
    path: "/Reports/WarehouseSummary",
    name: "Warehouse summary list",
    component: WarehouseList,
  },
  {
    path: "/Reports/ProductStock",
    name: "Stock product list",
    component: StockProductList,
  },






  {
    path: "/Connections/ImportedFiles",
    name: "Imported files list",
    component: ImportList,
  },
  {
    path: "/Connections/ImportedFiles/:id",
    name: "Imported file logs",
    component: ImportLogList,
  },


  //Customer service
  {
    path: "/CustomerService/Customers/Brands",
    name: "Customer service brands list",
    component: CustomerServiceBrandList,
  },
  {
    path: "/CustomerService/Customers/NewBrand/",
    name: "Customer service new brand",
    component: CustomerServiceNewBrand,
  },
  {
    path: "/CustomerService/Customers/BrandDetails/:id",
    name: "Customer service brand details",
    component: CustomerServiceBrandDetails,
  },

  //Administration
  {
    path: "/Integrations/AlierSGA/OrderOutboxQueueList",
    name: "Alier SGA Order outbox queue list",
    component: AdminOrderOutboxQueueList,
  },
  {
    path: "/Integrations/AlierSGA/OrderbackOutboxQueueList",
    name: "Alier SGA Orderback outbox queue list",
    component: AdminOrderBackOutboxQueueList,
  },
  {
    path: "/Integrations/AlierSGA/ProductOutboxQueueList",
    name: "Alier SGA Product outbox queue list",
    component: AdminProductOutboxQueueList,
  },
  {
    path: "/Integrations/AlierSGA/PurchaseOutboxQueueList",
    name: "Alier SGA Purchase outbox queue list",
    component: AdminPurchaseOutboxQueueList,
  },
  
  

];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

const publicPages = [
  "/Auth/Login",
  "/authentication/error/error404",
  "/authentication/error/error403",
  "/authentication/error/error500",
  "/docs",
];

/* router.beforeEach(async (to,from,next) => {
  const user = localStorage.getItem('user');
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/Auth/Login'];
  const authRequired = !publicPages.includes(to.path);
  if (to.name !== "Login Page" && authRequired && !user) {
    next("/Auth/Login");
  }
  else{
    let l = router.resolve({ path: to.path });
    if (l.matched.length > 0) {
      next();
    } else {
      //the route does not exists.
      next({ name: "Error404" });
    }
  } 
}); */

router.beforeEach((to, from, next) => {
  const user = localStorage.getItem("user");
  const authRequired = !publicPages.includes(to.path);

  if (authRequired && !user) {
    return next("/Auth/Login");
  }

  if (!to.matched.length) {
    return next({ name: "Error404" });
  }

  next();
});

export default router;
